import { useRef, useState } from 'react';
import JoditEditor from 'jodit-react';

const SidePanel = ({ isOpen }) => {
  const editor = useRef(null);
  const [content, setContent] = useState('');

  const config = {
    placeholder: 'Scratchpad to put any temporary notes here.',
    allowResizeX: false,
    allowResizeY: false,
    readonly: false, // all options from https://xdsoft.net/jodit/docs/
    height: '100% !important', // Re-add height config
    showCharsCounter: false,
    askBeforePasteHTML: false, // Don't ask before pasting HTML, this prevents a bug where nothing happens
    askBeforePasteFromWord: false,// Don't ask before pasting Word, this prevents a bug where nothing happens
    showWordsCounter: false,
    showXPathInStatusbar: false,
    addNewLine: false,
    style: {
      textAlign: 'left'
    }
    // Add other Jodit options as needed
  };

  if (!isOpen) {
    return null; // Don't render if the panel is closed
  }

  return (
    <div className="side-panel pagewrapper">
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        tabIndex={1} // tabIndex of textarea
        onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
        // onChange={newContent => {}}
      />
    </div>
  );
};

export default SidePanel; 